import { postSessionEvent } from "@src/api/ai/execute-workflows/post-session-event";
import { createAsyncThunk } from "@src/store/createAsyncThunk";
import { getAiChatSessionId } from "@src/store/slices/aiChat";

/**
 * Tell the AI server about a builder session event, so the Viv chat mirror can
 * annotate the thread. The event `type` is the action itself (`"saved"` /
 * `"discarded"` / `"interrupted"`) — the AI-server consumer scopes events to
 * the session's workflow, so it needs no namespacing. No-op when there's no Viv
 * chat session, and best-effort otherwise — a failed notification never blocks
 * the user action that triggered it.
 */
export const notifyBuilderEvent = createAsyncThunk<
  void,
  "saved" | "discarded" | "interrupted"
>("experienceBuilder/notifyBuilderEvent", async (type, { getState }) => {
  const sessionId = getAiChatSessionId(getState());
  if (!sessionId) {
    return;
  }
  try {
    await postSessionEvent(sessionId, type);
  } catch {
    // Best-effort telemetry; swallow so the user's save/discard is unaffected.
  }
});
